import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/AutoTranscribe.vue"),
    meta: {
      title: "Auto Transcribe - TV",
    },
    name: "tv-auto-transcribe",
    path: "/tv-auto-transcribe",
    props: (route) => ({ medium: "TV", ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/tv/TvItemsList.vue"),
    meta: {
      title: "TV Items",
    },
    name: "tv-items-list",
    path: "/tv_items",
    props: true,
  },
  {
    component: () => import("pages/tv/TvCaptionNew.vue"),
    meta: {
      title: "New TV Caption",
    },
    name: "tv-caption-new",
    path: "/tv_caption/new",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/tv/TvCaptionEdit.vue"),
    meta: {
      title: "Edit TV Caption",
    },
    name: "tv-caption-edit",
    path: "/tv_caption/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/tv/TvSuperNew.vue"),
    meta: {
      title: "New TV Super",
    },
    name: "tv-super-new",
    path: "/tv_super/new",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/tv/TvSuperEdit.vue"),
    meta: {
      title: "Edit TV Super",
    },
    name: "tv-super-edit",
    path: "/tv_super/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/tv/TvChannelList.vue"),
    meta: {
      title: "TV Channels",
    },
    name: "tv-channels-list",
    path: "/tv-channels",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/tv/TvChannelEdit.vue"),
    meta: {
      title: "New TV Channel",
    },
    name: "tv-channels-new",
    path: "/tv-channels/new",
  },
  {
    component: () => import("pages/tv/TvChannelEdit.vue"),
    meta: {
      title: "Edit TV Channel",
    },
    name: "tv-channels-edit",
    path: "/tv-channels/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/tv/TvProgramCategoryList.vue"),
    meta: {
      title: "TV Program Categories",
    },
    name: "tv-program-categories-list",
    path: "/tv-program-categories",
    props: true,
  },
  {
    component: () => import("pages/tv/TvProgramCategoryEdit.vue"),
    meta: {
      title: "New TV Program Category",
    },
    name: "tv-program-categories-new",
    path: "/tv-program-categories/new",
  },
  {
    component: () => import("pages/tv/TvProgramCategoryEdit.vue"),
    meta: {
      title: "Edit TV Program Category",
    },
    name: "tv-program-categories-edit",
    path: "/tv-program-categories/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/tv/TvChannelSchedule.vue"),
    meta: {
      title: "TV Channel Schedule",
    },
    name: "tv-channels-schedule",
    path: "/tv-channels/:id/schedule",
    props: true,
  },
  {
    component: () => import("pages/TvProgramList.vue"),
    meta: {
      title: "TV Programs",
    },
    name: "tv-programs-list",
    path: "/tv_programs",
    props: true,
  },
  {
    component: () => import("pages/TvProgramEdit.vue"),
    meta: {
      title: "New TV Program",
    },
    name: "tv-programs-new",
    path: "/tv_programs/new",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/TvProgramEdit.vue"),
    meta: {
      title: "Edit TV Program",
    },
    name: "tv-programs-edit",
    path: "/tv_programs/:id",
    props: true,
  },
  {
    component: () => import("pages/tv/TvPlayerPage.vue"),
    meta: {
      title: "TV Player",
    },
    name: "tv-player",
    path: "/tv-player",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/TvMediaRequestEdit.vue"),
    meta: {
      title: "New TV Media Item",
    },
    name: "tv-media-requests-new",
    path: "/tv-media-requests/new",
  },
  {
    component: () => import("pages/TvMediaRequestEdit.vue"),
    meta: {
      title: "Edit TV Media Item",
    },
    name: "tv-media-requests-edit",
    path: "/tv-media-requests/:tvMediaRequestId/edit",
    props: true,
  },
  {
    component: () => import("pages/tv/TvClipList.vue"),
    meta: {
      accessLevel: "content_removal",
      title: "TV Clips",
    },
    name: "tv-clips",
    path: "/tv-clips",
    props: true,
  },
  {
    component: () =>
      import("src/modules/BroadcastStory/pages/BroadcastStoryList/BroadcastStoryList.vue"),
    meta: {
      title: "TV Story List",
    },
    name: "tv-stories",
    path: "/tv-stories",
    props: () => ({ broadcastType: "Tv" }),
  },
  {
    component: () =>
      import("src/modules/BroadcastStory/pages/BroadcastStoryPage/BroadcastStoryPage.vue"),
    meta: {
      title: "TV Story Page",
    },
    name: "tv-stories-page",
    path: "/tv-stories/:id",
    props: true,
  },
];
